module.exports = __webpack_public_path__ + "img/explain_03.92142128.jpg";